import { createElement } from 'react';
import PropTypes from 'prop-types';

import useD3 from 'hooks/use-d3';

const D3 = ({ data, spec, width, height, className }) => {
  const { fn, nodeType } = spec;

  const ref = useD3(root => fn(root, data, width, height), [
    data,
    width,
    height,
  ]);

  return createElement(nodeType, {
    ref,
    style: { width, height },
    className,
  });
};

D3.defaultProps = {
  data: { documents: [] },
  spec: { fn: () => {}, nodeType: 'svg' },
};

D3.propTypes = {
  data: PropTypes.shape({
    documents: PropTypes.array.isRequired,
  }),
  spec: PropTypes.shape({
    fn: PropTypes.func.isRequired,
    nodeType: PropTypes.oneOf(['svg', 'canvas']).isRequired,
  }),
};

export default D3;
export { D3 };
